import { Box, Chip } from "@mui/material";
import { convertToTitleCase } from "../../../helpers/Utils";
import { orderEntries, useStatusParamFilter } from "../hooks/useStatusParamFilter";

/** Mobile counterpart of OrderFilter — same URL-param semantics via useStatusParamFilter. */
export default function StatusChipStrip({
  data,
  defaultSelect,
  paramName = "filter_status",
}) {
  const { selected: selectedIndex, select: handleChipClick } = useStatusParamFilter({
    defaultSelect,
    paramName,
  });

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        overflowX: "auto",
        py: 1,
        px: 1,
        WebkitOverflowScrolling: "touch",
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none",
      }}
    >
      {orderEntries(data).map(([filter, count]) => (
        <Chip
          key={filter}
          label={`${convertToTitleCase(filter)} (${count})`}
          variant={selectedIndex === filter ? "filled" : "outlined"}
          color={selectedIndex === filter ? "primary" : "default"}
          onClick={() => handleChipClick(filter)}
          sx={{ flexShrink: 0 }}
        />
      ))}
    </Box>
  );
}
